import { render, staticRenderFns } from "./LogAdmin.vue?vue&type=template&id=05384d5c&scoped=true&"
import script from "./LogAdmin.ts?vue&type=script&lang=ts&"
export * from "./LogAdmin.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05384d5c",
  null
  
)

export default component.exports
import {QSplitter,QTabs,QTab,QTabPanels,QTabPanel,QInput,QPopupProxy,QDate,QIcon,QSelect,QItem,QItemSection,QBtn,QSpinnerGears,QTable,QSpace,QTr,QTd} from 'quasar'
component.options.components = Object.assign({QSplitter,QTabs,QTab,QTabPanels,QTabPanel,QInput,QPopupProxy,QDate,QIcon,QSelect,QItem,QItemSection,QBtn,QSpinnerGears,QTable,QSpace,QTr,QTd}, component.options.components || {})
